import { Fragment } from "react";

type Props = {
  text: string | null | undefined;
  query: string;
};

// Renders `text` with all (case-insensitive) substring matches of `query`
// wrapped in <mark>. If query is empty or no match, returns plain text.
export function Mark({ text, query }: Props) {
  const t = String(text ?? "");
  const q = query.trim();
  if (!q) return <>{t}</>;
  const lowered = t.toLowerCase();
  const ql = q.toLowerCase();
  const parts: Array<{ text: string; hit: boolean }> = [];
  let i = 0;
  while (i < t.length) {
    const next = lowered.indexOf(ql, i);
    if (next === -1) {
      parts.push({ text: t.slice(i), hit: false });
      break;
    }
    if (next > i) parts.push({ text: t.slice(i, next), hit: false });
    parts.push({ text: t.slice(next, next + ql.length), hit: true });
    i = next + ql.length;
  }
  if (parts.length === 1 && !parts[0].hit) return <>{t}</>;
  return (
    <>
      {parts.map((p, k) =>
        p.hit ? <mark key={k}>{p.text}</mark> : <Fragment key={k}>{p.text}</Fragment>,
      )}
    </>
  );
}
